export default {
  DELETED_MSG: 'message was deleted',
  ADD_MEMBERS: 'Add members',
  DEL_MEMBERS: 'Remove members',
  DEL_GROUP_CHAT: 'Delete group chat',
  SEARCH_BY_NAME: 'Search by name...',
  START_SEARCH_BY_USER_NAME: 'Start searching users by name...',
  GROUP_CHAT: 'Group Chat',
  CHANGE_ADMIN: 'Change Admin',
  PROMPT_DEL_ROOM: 'Are you sure you want to permanently delete this room?',
  USER_ACTIVE: 'Active',
  USER_INACTIVE: 'Inactive',
  SEND: 'Send',
  DOWNLOAD_FILE: 'Download File',
  // The refreshed assistant shell localizes navigation, actions, composer guidance, and modal copy.
  ASSISTANT_EYEBROW: 'AI assistant',
  ASSISTANT_SELECTOR: 'Choose an assistant',
  ALERTS: 'Notifications and scheduled actions',
  CONTACT_EXPERT: 'Contact an expert',
  YOU: 'You',
  QUICK_ACTIONS: 'Quick actions',
  MORE_ACTIONS: 'More actions',
  ACTIONS_MODAL_TITLE: 'What would you like to do?',
  ACTIONS_MODAL_DESCRIPTION: 'Choose an action and adapt the prepared request before sending it.',
  ACTIONS_EMPTY_TITLE: 'No action is available',
  ACTIONS_EMPTY_DESCRIPTION: 'Emye will suggest contextual actions as the conversation progresses.',
  COMPOSER_LABEL: 'Message to the assistant',
  COMPOSER_PLACEHOLDER: 'Describe your need or choose a suggested action…',
  ATTACH_FILE: 'Attach a file',
  SEND_MESSAGE: 'Send message',
  PROCESSING: 'Emye is preparing the response',
  AI_DISCLAIMER: 'AI assistants can make mistakes. Check important information before using it.',
  SUGGESTIONS_LOAD_ERROR: 'Unable to load quick actions.',
  // Historical generated files remain listed after their temporary workspace artifact expires.
  GENERATED_FILE_UNAVAILABLE: 'This document has expired or is no longer available.',
  // Structured interaction chrome is localized while model-authored prompts remain plain response text.
  INTERACTION_QUESTION_PROGRESS: 'Question {{current}} of {{total}}',
  INTERACTION_OTHER: 'Other',
  INTERACTION_OTHER_PLACEHOLDER: 'Enter another answer',
  INTERACTION_TEXT_PLACEHOLDER: 'Enter your answer',
  INTERACTION_PREVIOUS: 'Previous',
  INTERACTION_CONTINUE: 'Continue',
  INTERACTION_SEND_ANSWERS: 'Send answers',
  INTERACTION_ANSWERED: 'Answered',
  INTERACTION_FREE_ANSWER: 'Free answer',
  INTERACTION_FOLLOW_UP_TITLE: 'Suggested next actions',
  INTERACTION_SINGLE_SELECT_HINT: 'Choose one option to continue.',
  INTERACTION_MULTI_SELECT_HINT: 'Choose one or more options, then continue.',
  INTERACTION_INVALID: 'These answers are invalid. Please try again.',
  INTERACTION_STALE: 'This question is no longer active. The conversation has been refreshed.',
  // Complex workflow chrome is local while individual step titles and summaries come from Emye in the selected language.
  WORKFLOW_TITLE: 'Task plan',
  WORKFLOW_PROGRESS: 'Complex task progress',
  WORKFLOW_BUILDING_PLAN: 'Preparing a reliable plan',
  WORKFLOW_PHASE_PLANNING: 'Planning the steps',
  WORKFLOW_PHASE_EXECUTING: 'Executing the plan',
  WORKFLOW_PHASE_FINALIZING: 'Checking the final result',
  WORKFLOW_STEP_PENDING: 'Waiting',
  WORKFLOW_STEP_IN_PROGRESS: 'In progress',
  WORKFLOW_STEP_COMPLETED: 'Completed and verified',
  WORKFLOW_STEP_FAILED: 'Could not be verified',
}
